(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-animated-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-platform-hero]:not([data-platform-hero-ready])').forEach((hero) => {
      hero.dataset.platformHeroReady = 'true';
      const scene = hero.querySelector('.platform-hero__scene');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!scene || reducedMotion.matches) return;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          hero.classList.toggle('is-motion-paused', !entries[0].isIntersecting);
        }, { threshold: 0.1 }).observe(hero);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["interactive-specs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.interactive-specs:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      const tabs = section.querySelectorAll('[data-specs-tab]');
      const panels = section.querySelectorAll('[data-specs-panel]');
      const selectTab = (tab, shouldFocus) => {
        const target = tab.dataset.specsTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { const active = panel.dataset.specsPanel === target; panel.hidden = !active; panel.classList.toggle('is-active', active); });
        if (shouldFocus) tab.focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          selectTab(tabs[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-asset-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-live-asset-grid]:not([data-ready])').forEach((grid) => {
      grid.dataset.ready = 'true';
      const tabs = grid.querySelectorAll('[data-asset-tab]');
      const panels = grid.querySelectorAll('[data-asset-panel]');
      const selectTab = (tab, shouldFocus) => {
        const target = tab.dataset.assetTab;
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.assetPanel !== target; });
        if (shouldFocus) tab.focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          selectTab(tabs[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-before-after-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var stage = root.querySelector('.mp-ba-stage');
    var handle = root.querySelector('.mp-ba-handle');
    if (!stage || !handle) return;

    var vertical = stage.getAttribute('data-orientation') === 'vertical';
    var start = parseFloat(stage.getAttribute('data-start'));
    if (isNaN(start)) start = 50;
    var dragging = false;

    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      stage.style.setProperty('--mp-pos', p);
      var rounded = Math.round(p);
      handle.setAttribute('aria-valuenow', String(rounded));
      handle.setAttribute('aria-valuetext', rounded + '%');
    }

    function posFromEvent(e) {
      var r = stage.getBoundingClientRect();
      if (vertical) {
        return ((e.clientY - r.top) / r.height) * 100;
      }
      return ((e.clientX - r.left) / r.width) * 100;
    }

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      stage.classList.add('is-dragging');
      if (stage.setPointerCapture) {
        try {
          stage.setPointerCapture(e.pointerId);
        } catch (err) { /* pointer already released */ }
      }
      setPos(posFromEvent(e));
      e.preventDefault();
    });

    stage.addEventListener('pointermove', function (e) {
      if (dragging) setPos(posFromEvent(e));
    });

    function endDrag() {
      dragging = false;
      stage.classList.remove('is-dragging');
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(handle.getAttribute('aria-valuenow'));
      if (isNaN(cur)) cur = start;
      var next = null;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        next = cur - 2;
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        next = cur + 2;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = 100;
      }
      if (next !== null) {
        e.preventDefault();
        setPos(next);
      }
    });

    setPos(start);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-ba]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-card-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_CLASS = 'mp-cardstack';
  var SPRING = 'cubic-bezier(0.34, 1.4, 0.64, 1)';

  function init(root) {
    if (!root || root.getAttribute('data-mp-init') === '1') return;
    root.setAttribute('data-mp-init', '1');

    var deck = root.querySelector('.mp-deck');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.mp-card'));
    var total = cards.length;
    if (!deck || total === 0) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var order = cards.map(function (_, i) { return i; });
    var animating = false;
    var dragging = false;

    var live = root.querySelector('[data-live]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var dotsWrap = root.querySelector('[data-dots]');

    var autoplayOn = root.getAttribute('data-autoplay') === 'true';
    var intervalMs = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var timer = null;
    var hoverPaused = false;
    var focusPaused = false;

    if (total <= 1) root.classList.add('is-single');

    function currentTop() { return order[0]; }

    function announce() {
      if (live) live.textContent = 'Review ' + (currentTop() + 1) + ' of ' + total;
    }

    function onTransitionEnd(el, cb, timeout) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.removeEventListener('transitionend', onEnd);
        cb();
      }
      function onEnd(e) {
        if (e.target === el) finish();
      }
      el.addEventListener('transitionend', onEnd);
      setTimeout(finish, timeout || 500);
    }

    function layout(progress, skipTop) {
      var p = progress || 0;
      order.forEach(function (idx, depth) {
        var card = cards[idx];
        var isTop = depth === 0;
        card.style.zIndex = String(total - depth);
        card.classList.toggle('is-top', isTop);
        card.setAttribute('aria-hidden', isTop ? 'false' : 'true');
        if (isTop && skipTop) return;
        if (isTop) {
          card.style.transform = 'translate3d(0,0,0) scale(1)';
          card.style.opacity = '1';
        } else {
          var y = Math.round(depth * 14 * (1 - p * 0.55));
          var s = 1 - Math.min(depth, 3) * 0.045;
          card.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + s.toFixed(3) + ')';
          card.style.opacity = depth > 4 ? '0' : '1';
        }
      });
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot) {
          var active = Number(dot.getAttribute('data-goto')) === currentTop();
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function scheduleAutoplay() {
      stopAutoplay();
      if (!autoplayOn || reduceMotion || total <= 1 || dragging || document.hidden || hoverPaused || focusPaused) return;
      timer = setInterval(function () {
        if (!dragging && !animating) advance({ dir: 1 });
      }, intervalMs);
    }

    function afterChange() {
      animating = false;
      announce();
      scheduleAutoplay();
    }

    function advance(opts) {
      opts = opts || {};
      if (animating || total <= 1) return;
      animating = true;
      stopAutoplay();
      var el = cards[currentTop()];
      var dir = opts.dir || 1;
      function cleanup() {
        el.style.transition = 'none';
        el.style.transform = '';
        el.style.opacity = '';
        order.push(order.shift());
        layout(0);
        void el.offsetWidth;
        el.style.transition = '';
        afterChange();
      }
      if (reduceMotion) { cleanup(); return; }
      var w = el.offsetWidth || 320;
      el.style.transition = 'transform 0.38s ' + SPRING + ', opacity 0.3s ease';
      el.style.transform = 'translate3d(' + Math.round(dir * w * 1.4) + 'px, 70px, 0) rotate(' + (dir * 16) + 'deg)';
      el.style.opacity = '0';
      onTransitionEnd(el, cleanup, 480);
    }

    function retreat() {
      if (animating || total <= 1) return;
      animating = true;
      stopAutoplay();
      order.unshift(order.pop());
      var el = cards[currentTop()];
      layout(0, true);
      if (reduceMotion) {
        el.style.transition = 'none';
        el.style.transform = '';
        el.style.opacity = '';
        afterChange();
        return;
      }
      el.style.zIndex = String(total + 1);
      el.style.transition = 'none';
      el.style.transform = 'translate3d(-140px, 24px, 0) rotate(-10deg) scale(1)';
      el.style.opacity = '0';
      void el.offsetWidth;
      el.style.transition = 'transform 0.42s ' + SPRING + ', opacity 0.3s ease';
      el.style.transform = 'translate3d(0,0,0) scale(1)';
      el.style.opacity = '1';
      onTransitionEnd(el, function () {
        el.style.transition = '';
        afterChange();
      }, 520);
    }

    /* ---- drag ---- */
    var startX = 0, startY = 0, dragDX = 0, dragDY = 0;
    var cardW = 0, threshold = 120, activeCard = null;

    deck.addEventListener('pointerdown', function (e) {
      if (animating || total <= 1 || dragging) return;
      var card = e.target.closest ? e.target.closest('.mp-card') : null;
      if (!card || !card.classList.contains('is-top')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      stopAutoplay();
      activeCard = card;
      startX = e.clientX; startY = e.clientY;
      dragDX = 0; dragDY = 0;
      cardW = card.offsetWidth;
      threshold = Math.max(100, cardW * 0.3);
      card.classList.add('is-dragging');
      card.style.transition = 'none';
      try { card.setPointerCapture(e.pointerId); } catch (err) {}
    });

    deck.addEventListener('pointermove', function (e) {
      if (!dragging || !activeCard) return;
      dragDX = e.clientX - startX;
      dragDY = e.clientY - startY;
      var rot = Math.max(-12, Math.min(12, dragDX * 0.06));
      activeCard.style.transform = 'translate3d(' + Math.round(dragDX) + 'px,' + Math.round(dragDY) + 'px,0) rotate(' + rot.toFixed(2) + 'deg)';
      var p = Math.min(Math.abs(dragDX) / threshold, 1);
      layout(p, true);
    });

    function endDrag() {
      if (!dragging || !activeCard) return;
      dragging = false;
      var card = activeCard;
      activeCard = null;
      card.classList.remove('is-dragging');
      var dir = dragDX >= 0 ? 1 : -1;

      if (Math.abs(dragDX) >= threshold) {
        animating = true;
        var w = cardW || card.offsetWidth || 320;
        var flungDY = dragDY;
        function cleanup() {
          card.style.transition = 'none';
          card.style.transform = '';
          card.style.opacity = '';
          order.push(order.shift());
          layout(0);
          void card.offsetWidth;
          card.style.transition = '';
          afterChange();
        }
        if (reduceMotion) { cleanup(); return; }
        card.style.transition = 'transform 0.36s ' + SPRING + ', opacity 0.3s ease';
        card.style.transform = 'translate3d(' + Math.round(dir * w * 1.5) + 'px,' + Math.round(flungDY * 2) + 'px,0) rotate(' + (dir * 18) + 'deg)';
        card.style.opacity = '0';
        onTransitionEnd(card, cleanup, 480);
      } else {
        layout(0, true);
        if (!reduceMotion) {
          card.style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
        } else {
          card.style.transition = 'none';
        }
        card.style.transform = 'translate3d(0,0,0) rotate(0deg)';
        onTransitionEnd(card, function () {
          card.style.transition = '';
          scheduleAutoplay();
        }, 500);
      }
    }
    deck.addEventListener('pointerup', endDrag);
    deck.addEventListener('pointercancel', endDrag);

    /* ---- controls ---- */
    if (prevBtn) prevBtn.addEventListener('click', retreat);
    if (nextBtn) nextBtn.addEventListener('click', function () { advance({ dir: 1 }); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest ? e.target.closest('[data-goto]') : null;
        if (!dot || animating) return;
        var target = Number(dot.getAttribute('data-goto'));
        if (target === currentTop()) return;
        stopAutoplay();
        var guard = 0;
        while (order[0] !== target && guard++ < total) { order.push(order.shift()); }
        var el = cards[currentTop()];
        layout(0, true);
        if (!reduceMotion) {
          el.style.transition = 'none';
          el.style.transform = 'translate3d(60px, 12px, 0) scale(0.98)';
          el.style.opacity = '0';
          void el.offsetWidth;
          el.style.transition = 'transform 0.38s ' + SPRING + ', opacity 0.3s ease';
          el.style.transform = 'translate3d(0,0,0) scale(1)';
          el.style.opacity = '1';
          onTransitionEnd(el, function () { el.style.transition = ''; }, 480);
        } else {
          el.style.transition = 'none';
          el.style.transform = '';
          el.style.opacity = '';
        }
        announce();
        scheduleAutoplay();
      });
    }

    deck.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        advance({ dir: 1 });
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        retreat();
      }
    });

    /* ---- autoplay pause conditions ---- */
    root.addEventListener('mouseenter', function () { hoverPaused = true; stopAutoplay(); });
    root.addEventListener('mouseleave', function () { hoverPaused = false; scheduleAutoplay(); });
    root.addEventListener('focusin', function () { focusPaused = true; stopAutoplay(); });
    root.addEventListener('focusout', function () { focusPaused = false; scheduleAutoplay(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else scheduleAutoplay();
    });

    layout(0);
    announce();
    scheduleAutoplay();
  }

  function boot() {
    var nodes = document.querySelectorAll('.' + window.CSS.escape(ROOT_CLASS));
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target && e.target.querySelector
      ? e.target.querySelector('.' + window.CSS.escape(ROOT_CLASS))
      : null;
    if (node) init(node);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-flip-clock-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    function init(root) {
      var target = parseInt(root.getAttribute('data-target'), 10);
      if (!target || isNaN(target)) return;

      var action = root.getAttribute('data-expiry-action') || 'show_message';
      var digits = root.querySelectorAll('[data-digit]');
      var timerEl = root.querySelector('[data-timer]');
      var msgEl = root.querySelector('[data-expired-message]');
      var customEl = root.querySelector('[data-expired-custom]');
      var srEl = root.querySelector('[data-sr]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timerId = null;
      var expired = false;
      var lastMinute = -1;

      function flip(digit, newVal) {
        var cur = digit.getAttribute('data-value');
        if (cur === newVal) return;
        digit.setAttribute('data-value', newVal);

        var staticTop = digit.querySelector('[data-static-top]');
        var staticBottom = digit.querySelector('[data-static-bottom]');

        if (reduceMotion) {
          staticTop.textContent = newVal;
          staticBottom.textContent = newVal;
          return;
        }

        var flapTop = digit.querySelector('[data-flap-top]');
        var flapBottom = digit.querySelector('[data-flap-bottom]');
        flapTop.textContent = cur;
        flapBottom.textContent = newVal;
        staticTop.textContent = newVal;
        staticBottom.textContent = cur;

        digit.classList.remove('is-flipping');
        void digit.offsetWidth;
        digit.classList.add('is-flipping');

        window.setTimeout(function () {
          staticBottom.textContent = newVal;
          digit.classList.remove('is-flipping');
        }, 680);
      }

      function expire() {
        if (expired) return;
        expired = true;
        if (timerId) { window.clearInterval(timerId); timerId = null; }
        if (timerEl) timerEl.setAttribute('hidden', '');
        var customText = customEl ? customEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (action === 'show_custom_text' && customText !== '' && customEl) {
          customEl.removeAttribute('hidden');
        } else if (action === 'hide_timer') {
          /* timer block already hidden; nothing else to show */
        } else if (msgEl) {
          msgEl.removeAttribute('hidden');
        }
        if (srEl) srEl.textContent = 'This offer has ended.';
      }

      function tick() {
        var now = Math.floor(Date.now() / 1000);
        var diff = target - now;
        if (diff <= 0) { expire(); return; }

        var d = Math.floor(diff / 86400);
        var realDays = d;
        if (d > 99) d = 99;
        var h = Math.floor((diff % 86400) / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        var str = pad2(d) + pad2(h) + pad2(m) + pad2(s);

        for (var i = 0; i < digits.length && i < str.length; i++) {
          flip(digits[i], str.charAt(i));
        }

        if (srEl && m !== lastMinute) {
          lastMinute = m;
          srEl.textContent = realDays + ' days, ' + h + ' hours, ' + m + ' minutes remaining';
        }
      }

      function start() {
        tick();
        if (!expired && !timerId) timerId = window.setInterval(tick, 1000);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (timerId) { window.clearInterval(timerId); timerId = null; }
        } else {
          start();
        }
      });

      start();
    }

    var roots = document.querySelectorAll('[data-mp-fc]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-neumorphic-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function init(root) {
    var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('.mp-faq__item'));

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('.mp-faq__q');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.mp-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (willOpen && !allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, willOpen);
      });
    });
    }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-faq]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-scroll-story-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
  var list = root.querySelector('[data-mp-ss-list]');
  var fill = root.querySelector('[data-mp-ss-fill]');
  if (!list || !fill) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var steps = root.querySelectorAll('[data-mp-ss-step]');

  /* ---- spring cards in on scroll ---- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      Array.prototype.forEach.call(entries, function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(steps, function (step) { io.observe(step); });
    Array.prototype.forEach.call(steps, function (step) { step.classList.add('is-visible'); });
  }

  /* ---- progress line draws itself as you scroll (rAF-throttled) ---- */
  var ticking = false;
  function updateFill() {
    ticking = false;
    var rect = list.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var total = rect.height;
    if (total <= 0) {
      fill.style.transform = 'scaleY(0)';
      return;
    }
    var passed = vh * 0.55 - rect.top;
    var p = passed / total;
    if (p < 0) p = 0;
    if (p > 1) p = 1;
    fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
  }
  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    if (reduceMotion) {
      updateFill();
    } else {
      window.requestAnimationFrame(updateFill);
    }
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  updateFill();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-ss-root]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var bar = root.querySelector('.mp-psa-bar');
    if (!bar) return;

    /* ---------- scroll-triggered visibility (rAF-throttled) ---------- */
    var trigger = parseInt(root.getAttribute('data-scroll-trigger'), 10);
    if (isNaN(trigger)) trigger = 600;
    var ticking = false;
    function updateVisibility() {
      bar.classList.toggle('is-visible', window.pageYOffset > trigger);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateVisibility);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();

    /* ---------- variant state ---------- */
    var jsonEl = root.querySelector('.mp-psa-variants-json');
    var variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    var btn = root.querySelector('.mp-psa-btn');
    var btnLabel = btn.querySelector('.mp-psa-btn-label');
    var defaultLabel = btn.getAttribute('data-label') || 'Add to cart';
    var redirectTarget = btn.getAttribute('data-redirect') === 'checkout' ? '/checkout' : '/cart';
    var priceEl = root.querySelector('.mp-psa-price');
    var compareEl = root.querySelector('.mp-psa-compare');
    var urgencyEl = root.querySelector('.mp-psa-urgency');
    var thumbImg = root.querySelector('.mp-psa-thumb-img');
    var errorEl = root.querySelector('.mp-psa-error');
    var threshold = parseInt(root.getAttribute('data-stock-threshold'), 10);
    if (isNaN(threshold)) threshold = 5;
    var moneyFormat = priceEl ? (priceEl.getAttribute('data-money-format') || '[[AMOUNT]]') : '[[AMOUNT]]';

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents, moneyFormat);
        } catch (e) { /* fall through to local formatter */ }
      }
      var value = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('[[AMOUNT]]', value)
        .replace('[[AMOUNT_NO_DECIMALS]]', String(Math.round(cents / 100)))
        .replace('[[AMOUNT_COMMA]]', value.replace('.', ','));
    }

    function currentVariant() {
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return variants[0];
    }

    function updateUrgency(variant) {
      if (!urgencyEl) return;
      var tracked = variant.inventory_management === 'shopify';
      var qty = variant.inventory_quantity;
      var show = tracked && qty !== null && typeof qty !== 'undefined' && qty <= threshold && variant.available;
      urgencyEl.hidden = !show;
    }

    function updateVariant(variant) {
      if (!variant) return;
      btn.setAttribute('data-variant-id', String(variant.id));
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (variant.available) {
        btn.disabled = false;
        btnLabel.textContent = defaultLabel;
      } else {
        btn.disabled = true;
        btnLabel.textContent = 'Sold out';
      }
      if (thumbImg && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        thumbImg.src = src + (src.indexOf('?') === -1 ? '?width=200' : '&width=200');
        if (variant.featured_image.alt) thumbImg.alt = variant.featured_image.alt;
      }
      updateUrgency(variant);
    }

    /* ---------- variant option pills ---------- */
    var optionCount = variants[0].options ? variants[0].options.length : 0;
    var first = currentVariant();
    var selected = [first.option1, first.option2, first.option3].slice(0, optionCount);
    var optionGroups = root.querySelectorAll('.mp-psa-option');
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var pills = group.querySelectorAll('.mp-psa-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');
          selected[idx] = pill.getAttribute('data-value');
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (v.option1 === selected[0] &&
                (optionCount < 2 || v.option2 === selected[1]) &&
                (optionCount < 3 || v.option3 === selected[2])) {
              match = v;
              break;
            }
          }
          if (match) updateVariant(match);
        });
      });
    });
    updateVariant(first);

    /* ---------- add to cart ---------- */
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btnLabel.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(btn.getAttribute('data-variant-id'), 10),
          quantity: 1
        })
      }).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
        });
      }).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.setAttribute('aria-busy', 'false');
        btnLabel.textContent = 'Added!';
        window.setTimeout(function () {
          window.location.href = redirectTarget;
        }, 650);
      }).catch(function (err) {
        btn.classList.remove('is-loading');
        btn.setAttribute('aria-busy', 'false');
        btnLabel.textContent = defaultLabel;
        errorEl.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
        errorEl.hidden = false;
      });
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-psa]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-store-transformer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
  var mock = root.querySelector('[data-mp-mock]');
  if (!mock) return;

  var KEY_TO_CLASS = {
    announcement_bar: 'has-announcement-bar',
    sticky_bar: 'has-sticky-bar',
    countdown: 'has-countdown',
    trust_badges: 'has-trust-badges',
    free_shipping_bar: 'has-free-shipping-bar',
    faq: 'has-faq'
  };

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- toggle switches -> mock classes ---- */
  function applyToggle(input) {
    var cls = KEY_TO_CLASS[input.getAttribute('data-mp-feature')];
    if (!cls) return;
    mock.classList.toggle(cls, input.checked);
    input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
  }
  var toggles = root.querySelectorAll('[data-mp-feature]');
  Array.prototype.forEach.call(toggles, function (input) {
    applyToggle(input);
    input.addEventListener('change', function () { applyToggle(input); });
  });

  /* ---- cart count + add buttons ---- */
  var cartCount = root.querySelector('[data-mp-cart-count]');
  var cartTotal = cartCount ? parseInt(cartCount.textContent, 10) || 0 : 0;
  function bumpCart() {
    if (!cartCount) return;
    cartTotal += 1;
    cartCount.textContent = cartTotal;
    if (!reduceMotion) {
      cartCount.classList.add('mp-st-pop');
      setTimeout(function () { cartCount.classList.remove('mp-st-pop'); }, 320);
    }
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-mp-add]'), function (btn) {
    btn.addEventListener('click', function () {
      var added = btn.getAttribute('data-mp-added') === 'true';
      if (added) {
        btn.setAttribute('data-mp-added', 'false');
        btn.setAttribute('aria-pressed', 'false');
        btn.textContent = btn.getAttribute('data-mp-add-label') || 'Add';
      } else {
        btn.setAttribute('data-mp-add-label', btn.textContent);
        btn.setAttribute('data-mp-added', 'true');
        btn.setAttribute('aria-pressed', 'true');
        btn.textContent = 'Added';
        bumpCart();
      }
    });
  });
  var heroCta = root.querySelector('[data-mp-hero-cta]');
  if (heroCta) {
    heroCta.addEventListener('click', function () { bumpCart(); });
  }

  /* ---- mini FAQ accordions ---- */
  Array.prototype.forEach.call(root.querySelectorAll('.mp-st-faq-q'), function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* ---- ticking flip-clock countdown ---- */
  var clock = root.querySelector('[data-mp-countdown]');
  if (clock) {
    var digits = clock.querySelectorAll('.mp-st-digit');
    var remaining = 4 * 3600 + 23 * 60 + 11; /* 04:23:11 */
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function render() {
      var str = pad(Math.floor(remaining / 3600)) + pad(Math.floor((remaining % 3600) / 60)) + pad(remaining % 60);
      Array.prototype.forEach.call(digits, function (d, i) {
        var next = str.charAt(i);
        if (d.textContent !== next) {
          d.textContent = next;
          if (!reduceMotion && mock.classList.contains('has-countdown')) {
            d.classList.remove('mp-st-flip');
            void d.offsetWidth;
            d.classList.add('mp-st-flip');
          }
        }
      });
    }
    render();
    setInterval(function () {
      if (!mock.classList.contains('has-countdown')) return;
      remaining = remaining > 0 ? remaining - 1 : 24 * 3600 - 1;
      render();
    }, 1000);
  }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-st-root]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-tactile-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatMoney(cents, format) {
      var re = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}|\\[\\[(\\w+)\\]\\]');
      var fmt = String(format || '$[[AMOUNT]]');
      var m = fmt.match(re);
      var kind = m ? (m[1] || m[2] || 'amount').toLowerCase() : 'amount';
      var grouped = function (n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      var out;
      if (kind === 'amount_no_decimals') {
        out = grouped(Math.round(cents / 100));
      } else if (kind === 'amount_with_comma_separator') {
        out = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else {
        out = grouped((cents / 100).toFixed(2));
      }
      return fmt.replace(re, out);
    }

    function init(root) {
      var cards = root.querySelectorAll('.mp-bb-card[data-variant-id]');
      var selectable = [];
      var byId = {};
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].disabled) {
          selectable.push(cards[i]);
          byId[cards[i].getAttribute('data-variant-id')] = cards[i];
        }
      }

      var summary = root.querySelector('[data-summary]');
      if (!summary || selectable.length === 0) return;

      var tiers = [];
      try {
        tiers = JSON.parse(root.getAttribute('data-tiers') || '[]');
      } catch (e) {
        tiers = [];
      }
      tiers = tiers.filter(function (t) { return t && t.qty > 0; })
                   .sort(function (a, b) { return a.qty - b.qty; });

      var moneyFormat = root.getAttribute('data-money-format');
      var redirectTo = root.getAttribute('data-redirect') || 'cart';
      var buttonLabel = root.getAttribute('data-button-label') || 'Add bundle to cart';

      var tierChips = root.querySelector('[data-tier-chips]');
      var progressBlock = root.querySelector('[data-progress]');
      var barWrap = root.querySelector('[data-barwrap]');
      var bar = root.querySelector('[data-bar]');
      var barMsg = root.querySelector('[data-bar-msg]');
      var subtotalEl = root.querySelector('[data-subtotal]');
      var savingsEl = root.querySelector('[data-savings]');
      var totalEl = root.querySelector('[data-total]');
      var saveLine = root.querySelector('[data-save-line]');
      var btn = root.querySelector('[data-add-btn]');
      var hint = root.querySelector('[data-hint]');
      var errBox = root.querySelector('[data-error]');

      var selected = {};
      var selectedCount = 0;
      var adding = false;
      var chipRefs = [];

      function buildChips() {
        tierChips.innerHTML = '';
        chipRefs = [];
        tiers.forEach(function (t) {
          var chip = document.createElement('span');
          chip.className = 'mp-bb-chip';
          chip.textContent = t.label + ' \u00B7 ' + t.pct + '% off';
          tierChips.appendChild(chip);
          chipRefs.push({ qty: t.qty, el: chip });
        });
        if (tiers.length === 0 && progressBlock) progressBlock.setAttribute('hidden', '');
      }

      function activeTier() {
        var t = null;
        tiers.forEach(function (tier) { if (selectedCount >= tier.qty) t = tier; });
        return t;
      }

      function nextTier() {
        for (var k = 0; k < tiers.length; k++) {
          if (tiers[k].qty > selectedCount) return tiers[k];
        }
        return null;
      }

      function hideError() {
        errBox.setAttribute('hidden', '');
        errBox.textContent = '';
      }

      function update() {
        var subtotal = 0;
        for (var id in selected) {
          if (Object.prototype.hasOwnProperty.call(selected, id) && byId[id]) {
            subtotal += parseInt(byId[id].getAttribute('data-price'), 10) || 0;
          }
        }

        var active = activeTier();
        var next = nextTier();
        var pct = active ? active.pct : 0;
        var savings = Math.round(subtotal * pct / 100);
        var total = subtotal - savings;

        subtotalEl.textContent = formatMoney(subtotal, moneyFormat);
        savingsEl.textContent = savings > 0 ? '\u2212' + formatMoney(savings, moneyFormat) : '\u2014';
        totalEl.textContent = formatMoney(total, moneyFormat);

        if (savings > 0) {
          saveLine.textContent = 'You save ' + formatMoney(savings, moneyFormat) + ' (' + pct + '%)';
        } else if (selectedCount > 0) {
          saveLine.textContent = 'Add more products to unlock a bundle discount.';
        } else {
          saveLine.textContent = 'Bundle savings will appear here.';
        }

        if (tiers.length > 0) {
          var frac = next ? Math.min(selectedCount / next.qty, 1) : 1;
          bar.style.width = Math.round(frac * 100) + '%';
          barWrap.setAttribute('aria-valuenow', String(Math.round(frac * 100)));
          if (selectedCount === 0) {
            barMsg.textContent = 'Tap products to start building your bundle.';
          } else if (next) {
            var need = next.qty - selectedCount;
            barMsg.textContent = 'Add ' + need + ' more to unlock ' + next.label + ' \u2014 ' + next.pct + '% off.';
          } else {
            barMsg.textContent = active.label + ' unlocked \u2014 you get ' + active.pct + '% off!';
          }
        }

        chipRefs.forEach(function (c) {
          c.el.classList.toggle('is-active', !!(active && c.qty === active.qty));
          c.el.classList.toggle('is-next', !!(next && c.qty === next.qty && !active));
        });

        var ready = selectedCount > 0 && !adding;
        btn.disabled = !ready;
        btn.textContent = adding
          ? 'Adding\u2026'
          : (selectedCount > 0 ? buttonLabel + ' (' + selectedCount + ')' : buttonLabel);
        hint.hidden = selectedCount > 0;
      }

      selectable.forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        card.addEventListener('click', function () {
          if (selected[id]) {
            delete selected[id];
            selectedCount--;
            card.setAttribute('aria-pressed', 'false');
          } else {
            selected[id] = true;
            selectedCount++;
            card.setAttribute('aria-pressed', 'true');
          }
          hideError();
          update();
        });
      });

      btn.addEventListener('click', function () {
        if (adding || selectedCount === 0) return;
        adding = true;
        hideError();
        update();

        var ids = [];
        for (var id in selected) {
          if (Object.prototype.hasOwnProperty.call(selected, id)) ids.push(parseInt(id, 10));
        }

        Promise.all(ids.map(function (variantId) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          }).then(function (res) {
            if (!res.ok) throw new Error('add_failed');
            return res.json();
          });
        })).then(function () {
          window.location.href = redirectTo === 'checkout' ? '/checkout' : '/cart';
        }).catch(function () {
          adding = false;
          errBox.textContent = 'Something went wrong while adding your bundle. Please try again.';
          errBox.removeAttribute('hidden');
          update();
        });
      });

      buildChips();
      update();
    }

    var roots = document.querySelectorAll('[data-mp-bb]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-tilt-comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function init(root) {

    // Tilt is a fine-pointer, full-motion enhancement only.
    var finePointer = window.matchMedia('(pointer: fine)').matches;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reducedMotion) return;

    var MAX_DEG = 6;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.mp-tilt__card'));

    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--mp-ry', (px * MAX_DEG * 2).toFixed(2) + 'deg');
        card.style.setProperty('--mp-rx', (py * MAX_DEG * -2).toFixed(2) + 'deg');
      });

      card.addEventListener('mouseleave', function () {
        card.style.setProperty('--mp-rx', '0deg');
        card.style.setProperty('--mp-ry', '0deg');
      });
    });
    }

  function boot() {
    var nodes = document.querySelectorAll('[data-mp-tilt]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-volume-press-tiers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_CLASS = 'mp-voltiers';

  function init(root) {
    if (!root || root.getAttribute('data-mp-init') === '1') return;
    root.setAttribute('data-mp-init', '1');

    var mode = root.getAttribute('data-mode') || 'standalone';
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en-US';
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var tiersWrap = root.querySelector('.mp-tiers');
    var readout = root.querySelector('[data-readout]');
    if (!tiersWrap) return;

    var tiers = Array.prototype.slice.call(tiersWrap.querySelectorAll('.mp-tier'));
    var enabled = tiers.filter(function (t) { return !t.disabled && t.getAttribute('data-unit-cents'); });
    var atcBtn = root.querySelector('[data-atc]');
    var errorBox = root.querySelector('[data-error]');
    var formNotice = root.querySelector('[data-form-notice]');

    var state = { qty: 1, unitCents: 0, savePct: 0 };

    function formatMoney(cents) {
      var val = cents / 100;
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(val);
      } catch (e) {
        return '$' + val.toFixed(2);
      }
    }

    function updateReadout() {
      if (!readout) return;
      if (!state.unitCents) {
        readout.textContent = 'Choose a tier to see your total.';
        return;
      }
      var total = state.qty * state.unitCents;
      var text = state.qty + (state.qty === 1 ? ' unit' : ' units') +
        ' \u00D7 ' + formatMoney(state.unitCents) +
        ' = ' + formatMoney(total);
      if (state.savePct > 0) text += ' \u2014 you save ' + state.savePct + '%';
      readout.textContent = text;
    }

    function findQtyInput() {
      var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]');
      if (!inputs.length) return null;
      var best = null;
      Array.prototype.forEach.call(inputs, function (inp) {
        var form = inp.closest ? inp.closest('form') : null;
        if (form && (form.contains(root) || root.contains(form))) best = inp;
      });
      return best || inputs[0];
    }

    function syncProductForm() {
      var input = findQtyInput();
      if (!input) {
        if (designMode && formNotice) formNotice.hidden = false;
        return;
      }
      if (formNotice) formNotice.hidden = true;
      input.value = String(state.qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function selectTier(btn, focus) {
      if (!btn || btn.disabled) return;
      tiers.forEach(function (t) {
        t.classList.remove('is-selected');
        t.setAttribute('aria-checked', 'false');
        t.tabIndex = -1;
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');
      btn.tabIndex = 0;
      if (focus) btn.focus();
      state.qty = parseInt(btn.getAttribute('data-min-qty'), 10) || 1;
      state.unitCents = parseInt(btn.getAttribute('data-unit-cents'), 10) || 0;
      state.savePct = parseInt(btn.getAttribute('data-save-pct'), 10) || 0;
      updateReadout();
      if (mode === 'product_form') syncProductForm();
    }

    tiers.forEach(function (btn) {
      btn.addEventListener('click', function () { selectTier(btn, false); });
      btn.addEventListener('keydown', function (e) {
        var list = enabled;
        var i = list.indexOf(btn);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = list[(i + 1) % list.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = list[(i - 1 + list.length) % list.length];
        else if (e.key === 'Home') next = list[0];
        else if (e.key === 'End') next = list[list.length - 1];
        else return;
        e.preventDefault();
        if (next) selectTier(next, true);
      });
    });

    if (enabled.length) selectTier(enabled[0], false);
    else updateReadout();

    /* ---- standalone add to cart ---- */
    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
    }
    function hideError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function resolveVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return input.value;
      return root.getAttribute('data-variant-id') || null;
    }

    if (atcBtn && mode === 'standalone') {
      if (!enabled.length) atcBtn.disabled = true;
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        hideError();
        var variantId = resolveVariantId();
        if (!variantId) {
          showError('Sorry \u2014 we could not find a product variant. Please refresh the page and try again.');
          return;
        }
        var label = atcBtn.querySelector('[data-atc-label]');
        var original = label ? label.textContent : '';
        atcBtn.disabled = true;
        atcBtn.classList.add('is-loading');
        if (label) label.textContent = 'Adding\u2026';
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: state.qty })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error((data && data.description) || 'Could not add to cart.');
            });
          }
          return res.json();
        }).then(function () {
          var after = root.getAttribute('data-after') || 'cart';
          window.location.href = after === 'checkout' ? '/checkout' : '/cart';
        }).catch(function (err) {
          showError((err && err.message) || 'Something went wrong. Please try again.');
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-loading');
          if (label) label.textContent = original;
        });
      });
    }

    if (mode === 'product_form' && designMode && !findQtyInput() && formNotice) {
      formNotice.hidden = false;
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('.' + window.CSS.escape(ROOT_CLASS));
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target && e.target.querySelector
      ? e.target.querySelector('.' + window.CSS.escape(ROOT_CLASS))
      : null;
    if (node) init(node);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulp-brand-promise"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pulp-promise]:not([data-pulp-promise-ready])').forEach((section) => {
      section.dataset.pulpPromiseReady = 'true';
      const words = section.dataset.promiseWords.split('|').map((word) => word.trim()).filter(Boolean);
      const word = section.querySelector('[data-promise-word]');
      const motionWord = section.querySelector('[data-promise-motion-word]');
      if (words.length < 2 || !word || !motionWord || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let index = 0;
      let timer;
      let inView = true;
      let paused = false;
      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };
      const start = () => {
        if (timer || paused || !inView) return;
        timer = window.setInterval(() => {
          word.classList.add('is-changing');
          window.setTimeout(() => {
            index = (index + 1) % words.length;
            word.textContent = words[index];
            motionWord.textContent = words[index];
            word.classList.remove('is-changing');
          }, 180);
        }, 2800);
      };
      const sync = () => {
        stop();
        start();
      };

      section.addEventListener('mouseenter', () => {
        paused = true;
        stop();
      });
      section.addEventListener('mouseleave', () => {
        paused = false;
        start();
      });
      section.addEventListener('focusin', () => {
        paused = true;
        stop();
      });
      section.addEventListener('focusout', () => {
        paused = false;
        start();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.25 }).observe(section);
      }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
